export abstract class Exception extends Error {
  protected constructor(message: string) {
    super(message);
  }

  static isInstance<T>(error: T): error is T {
    return error instanceof this;
  }
}
